import React from "react"
import { Col, Row, Container, DropdownButton, Dropdown } from "react-bootstrap"
import "../../styles/help-center.scss"

function FilterSection() {
  return (
    <section id="filter-section">
      <Container>
        <Row className="bg-white">
          <Col md={3} className="pr-3">
            <div className="dropdown-bg">
              <select className="dropdown" name="" id="">
                <option selected disabled>
                  Choose Location
                </option>
              </select>
            </div>
          </Col>
          <Col md={3} className="pr-3">
            <div className="dropdown-bg">
              <select className="dropdown" name="" id="">
                <option selected disabled>
                 Kind of Help
                </option>
              </select>
            </div>
          </Col>
          <Col md={3} className="pr-3">
            <div className="dropdown-bg">
              <select className="dropdown" name="" id="">
                <option selected disabled>
                  Substance Use
                </option>
              </select>
            </div>
          </Col>

          <Col md={3}>
            <button className="find-btn btn">
              {/* <FontAwesomeIcon
                icon={faPhoneAlt}
                style={{ marginRight: "1rem" }}
              /> */}
              FIND
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default FilterSection
